import Content from "@/components/Content.tsx";
import Header from "@/Header.tsx";
import User_ProfileEdit from "@/user/User_ProfileEdit.tsx";
import {createFileRoute} from '@tanstack/react-router'
import React from "react";

export const Route = createFileRoute('/_app/profiles/$player_uid/edit')({
    component: RouteComponent,
})

function RouteComponent() {
    return <>
        <Header />
        <Content>
            <User_ProfileEdit />
        </Content>
    </>
}
